export interface Tracking {
    click: string;
    location: string;
    buttonName: string;
}

export const trackingAttributes = (tracking?: Tracking) => tracking && {
    'data-track-click': tracking.click,
    'data-track-location': tracking.location,
    'data-track-button-name': tracking.buttonName,
};
